"use client"

import { useState } from "react"

import Register from "@modules/account/components/register"
import Login from "@modules/account/components/login"

export enum LOGIN_VIEW {
  SIGN_IN = "sign-in",
  REGISTER = "register",
}

const LoginTemplate = ({
  showLogin,
}: {
  showLogin: boolean
}) => {
  const [currentView, setCurrentView] = useState("sign-in")



  return (
    <div className="w-full flex justify-start px-8 py-8">
      {showLogin ? (<>
        {currentView === "sign-in" ? (
          <Login setCurrentView={setCurrentView} />
        ) : (
          <Register setCurrentView={setCurrentView} />
        )}
      </>)
        : (
          <>
            <div className="flex items-center h-full">

              <p>You are not logged in o the system right now, please login through &nbsp; </p>
              <a
                href={process.env.NEXT_AMIE_LOGIN_URL}
                className="uppercase txt-compact-xlarge-plus hover:text-ui-fg-base"
                data-testid="nav-amie-login-link"
              >
                AMIE
              </a>
            </div>
          </>
        )
      }
    </div>
  )
}

export default LoginTemplate
